import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import type { UserProfile, UserListItem, UserLookupItem, ApiErrorResponse, UpdateUserProfileRequest, UserRole, AccessRequestsCountResponse, AccessRequest } from './userManagement.types';

const base = '/api/users';

export function getProfile(): Promise<ApiResponse<UserProfile>> {
	return apiClient.get<UserProfile>(`${base}/profile`);
}

export function updateProfile(payload: UpdateUserProfileRequest): Promise<ApiResponse<UserProfile>> {
	return apiClient.patch<UserProfile>(`${base}/profile`, payload);
}

export function listUsers(): Promise<ApiResponse<UserListItem[]>> {
	return apiClient.get<UserListItem[]>(`${base}`);
}

export function lookupUsers(): Promise<ApiResponse<UserLookupItem[]>> {
	return apiClient.get<UserLookupItem[]>(`${base}/lookup`);
}

export function listUsersByActivity(includeInactive: boolean): Promise<ApiResponse<UserListItem[]>> {
	return apiClient.get<UserListItem[]>(`${base}`, {
		params: { includeInactive },
	});
}

export function getRoles(): Promise<ApiResponse<UserRole[]>> {
	return apiClient.get<UserRole[]>(`${base}/roles`);
}

export function updateUserRole(userId: string, roleId: number): Promise<ApiResponse<UserListItem>> {
	return apiClient.patch<UserListItem>(`${base}/${encodeURIComponent(userId)}/role`, { newRoleId: roleId });
}

export function deleteUser(userId: string): Promise<ApiResponse<boolean>> {
	return apiClient.delete<boolean>(`${base}/${encodeURIComponent(userId)}`);
}

export function reactivateUser(userId: string): Promise<ApiResponse<ApiErrorResponse>> {
	return apiClient.post<ApiErrorResponse>(`${base}/${encodeURIComponent(userId)}/reactivate`, {});
}

export function deactivateUser(userId: string): Promise<ApiResponse<ApiErrorResponse>> {
	// Using the same reactivate endpoint as specified in requirements
	return apiClient.post<ApiErrorResponse>(`${base}/${encodeURIComponent(userId)}/reactivate`, {});
}

export function getAccessRequestsCount(): Promise<ApiResponse<AccessRequestsCountResponse>> {
	return apiClient.get<AccessRequestsCountResponse>(`${base}/access-requests/count`);
}

export function getAccessRequests(): Promise<ApiResponse<AccessRequest[]>> {
	return apiClient.get<AccessRequest[]>(`${base}/access-requests`);
}

export function deleteAccessRequest(requestId: number | string): Promise<ApiResponse<boolean>> {
    return apiClient.delete<boolean>(`${base}/delete-access-requests/${encodeURIComponent(String(requestId))}`);
}

